import { useEffect, useState, useRef } from "react";

const ScrollEntry = ({ ref, observerOptions }) => {
  const [entered, setEntered] = useState(false);
  const observer = useRef(
    new IntersectionObserver(([entry]) => {
      setEntered(entry.isIntersecting);
    }, observerOptions || { threshold: 0 })
  );

  useEffect(() => {
    const currentElement = ref.current;
    const currentObserver = observer.current;

    if (entered) {
      currentObserver.disconnect();
      return;
    }

    if (currentElement && !entered) {
      currentObserver.observe(currentElement);
    }

    return () => currentObserver.disconnect();
  }, [ref]);

  return entered;
};

export default ScrollEntry;
